<template>
<div>
    <div class="ibox sombra-light">
        <div class="ibox-title">
            <h5>
                <i class="fal fa-chart-bar"></i> Reporte Encuesta Watson
            </h5>
        </div>
        <div class="ibox-content">
            <form @submit.prevent="getreporte">
                <b-overlay :show="buttonDisable" rounded="sm">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Fecha de inicio</label>
                                <div class="input-group">
                                    <b-form-datepicker id="fechaInicioGrafico" v-model="form.fechaInicio" placeholder="Fecha de inicio" v-bind="datepicker.etiquetas[datepicker.idioma] || {}" :locale="datepicker.idioma" class="mb-2"></b-form-datepicker>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Fecha de término</label>
                                <div class="input-group">
                                    <b-form-datepicker id="fechaTerminoGrafico" v-model="form.fechaTermino" placeholder="Fecha de término" v-bind="datepicker.etiquetas[datepicker.idioma] || {}" :locale="datepicker.idioma" class="mb-2"></b-form-datepicker>
                                </div>
                            </div>
                        </div>
                        <div class="offset-md-6 col-md-6">
                            <b-button block variant="primary" type="submit" @submit="getreporte" :disabled="buttonDisable" :class="`buscar-info-dashboard`">Buscar</b-button>
                        </div>
                    </div>
                </b-overlay>
            </form>
        </div>
        <transition name="fade">
            <div class="graficos" v-if="mostrarGraficos">
                <div class="ibox sombra-light">
                    <div class="ibox-content">
                        <b-row>
                            <b-col cols="12">
                                <data-table :id="dt.id" :datos="dt.datos" :columnas="dt.columnas" :responsive="true" :font-size="12">
                                    <!-- <template v-slot:detalles="item">
                                        <div>
                                            <switchh v-model="item.data.revisada" :id="item.data.id" @toggle="toggle"/>
                                        </div>
                                    </template> -->
                                </data-table>

                            </b-col>
                        </b-row>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</div>
</template>

<script>
var moment = require('moment');
import { labels, locale } from "../../datepicker-intl.json";
import DataTable from '../../DataTableLuis.vue';
export default {
    components: { DataTable },
    data() {
        return {
            interacciones: [],
            form: {
                fechaInicio: moment().subtract(1, "day").format("YYYY-MM-DD"),
                fechaTermino: moment().format("YYYY-MM-DD"),
            },
            datepicker: {
                etiquetas: labels,
                idioma: locale,
            },
            buttonDisable: false,
            parametrosValidos: false,
            mostrarGraficos: false,
            dt: {
                id: 'dt',
                columnas: [
                    { nombre: 'Documento', nombre_variable: 'documento_paciente' },
                    { nombre: 'Nombre', nombre_variable: 'nombre_paciente' },
                    { nombre: 'Telefono', nombre_variable: 'telefono' },
                    { nombre: 'Tipo Agendamiento', nombre_variable: 'tipo_agendamiento' },
                    { nombre: 'Especialidad', nombre_variable: 'especialidad' },
                    { nombre: 'Calificacion', nombre_variable: 'calificacion' },
                    { nombre: 'Fecha', nombre_variable: 'created_at' },
                ],
                datos: []
            },
            prueba: false
        };
    },
    methods: {
        getreporte() {
            // console.log(this.form);
            this.buttonDisable = true;
            this.mostrarGraficos = true;
            this.dt.datos = []
            axios.post('', this.form).then(response => {
                this.dt.datos = response.data;
                this.buttonDisable = false;
            }).catch(error => {
                this.buttonDisable = false;
                console.log(error);
            })
        },
    },
}
</script>

